import jq from "jquery"

// Need to inject jQuery in param for testing purposes
export function confirm_read($ = jq) {
  if ($('[id^="approve-child_follow-form-modal-"]').length) {
    $("#approval_checkbox").on("change", function () {
      const isChecked = $(this).prop("checked")
      $("#submit_button").prop("disabled", !isChecked)
      $("#child_follow_form_approval_status").val(isChecked ? "true" : "false")
    })
  }
}
